<template>
  <div>

      <b-alert  :show="dismissCountDown"  :variant="typeAlert" @dismissed="dismissCountDown=0"
             @dismiss-count-down="countDownChanged" class="alert">
        {{textAlert}}
      </b-alert>


  </div>
</template>
<script>
export default {
  name: 'AlertsModalComponent',
  props: {
    lang: Object
  },
  data() {
    return {
      dismissSecs: 0,
      dismissCountDown: 0,

      typeAlert: 'success',
      textAlert: ''
    }
  },
  computed:{
    alertModalContainer(){
      return this.$store.getters.alertModalContainer
    }
  },
  methods: {
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.dismissCountDown = this.dismissSecs
    }
  },
  watch: {
    alertModalContainer: {
      handler: function(newVal, oldVal){
        
        this.textAlert = newVal.text;
        this.typeAlert = newVal.type;
        this.dismissSecs = newVal.time;
        this.showAlert();
      },
      deep: true
  
    },
    dismissCountDown: function (newVal, oldVal) {
      if (newVal == 0) {
        
      }
      
    }
  },
  
}
</script>
<style scoped>
  .alert{
    border: 1px solid #aaa;
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/AlertsModalComponent.vue